import { DinamikBilesen } from '@service/fikoyt-ui/decorators/dinamik-bilesen';
import { KaliteOlcumEditComponent } from './kalite-olcum-edit.component';
import { KaliteOlcumKartComponent } from './kalite-olcum-kart.component';

@DinamikBilesen({
  id: 'kalite-olcum',
  baslik: 'Kalite Ölçümü',
  aciklama: 'Kalite ölçüm kaydı',
  ikon: 'audit',
  kategori: 'kalite',
})
class KaliteOlcum {
  paylas_kutusu = KaliteOlcumEditComponent;
  paylasilmis_kart = KaliteOlcumKartComponent;
}
